import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	closeButtonLabel: {
		id: 'polaris-component-collection-create.drawer.close-button-label',
		defaultMessage: 'Close',
		description: 'Label for close button',
	},
});
